<template>
  <div class="pnf-main">
    <div>
      <CustomSide />
    </div>
    <div class="pnf-container">
      <div class="pnf-body">
        <div class="pnf-body-img">
          <img src="@/assets/img/error-alert.svg" alt="page not found" />
        </div>
        <div class="pnf-body-title">Página não encontrada!</div>
        <div class="pnf-body-subtitle">
          A página que procura não foi encontrada ou não existe.
        </div>
        <div class="pnf-body-button">
          <button
            class="btn btn-primary"
            @click="this.$router.push({ name: 'home' })"
          >
            Voltar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomSide from "@/components/CustomSide/customSide.vue";
export default {
  name: "page-not-found",
  components: {
    CustomSide,
  },
};
</script>
<style scoped>
.pnf-main {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  height: 100vh;
}
.pnf-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pnf-body {
  width: 300px;
}
.pnf-body-img {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pnf-body-title {
  margin-top: 32px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #000000;
  text-align: center;
}
.pnf-body-subtitle {
  margin-top: 24px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
}
.pnf-body-button {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pnf-body-button button {
  width: 100%;
  height: 56px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  border-radius: 15px;
}
@media screen and (min-width: 769px) {
  .pnf-main {
    flex-direction: row;
  }
  .pnf-container {
    overflow-y: auto;
  }
}
@media screen and (max-width: 768px) {
  .pnf-container {
    align-items: flex-start;
  }
}
</style>
